import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient from '~/ApiClient';

import mapRatesSettings from './mapRatesSettings';
import RatesSettings from './RatesSettings';

export interface Result {
	exchangeRatesSettings: RatesSettings;
}

export default async function updateExchangeRatesSettings(
	client: ApiClient,
	userId: string,
	groupId: string,
	type: string,
	date: Date | null,
	ratesId: string | null
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/exchange-rates-settings').expand({
		userId,
		groupId,
	});
	const request = await client.fetch(url, {
		method: 'PUT',
		body: JSON.stringify({
			type,
			date: date ? formatApiDate(date) : null,
			customExchangeRates:
				ratesId !== null
					? {
							id: ratesId,
					  }
					: null,
		}),
	});
	const response = await request.json();
	return {
		exchangeRatesSettings: mapRatesSettings(response.exchangeRatesSettings),
	};
}
